import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import $ from "jquery";

const UpdateBatteryDetails = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setRowAddData,
  rowAddData,
  setSelectedRowsData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [Staff, setStaff] = useState([]);
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function resetFileds() {
    setRowAddData({
      battery_num: "",
      battery_brand: "",
      specification: "",
      warrenty_guarantee: "",
      purchase_date: "",
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
    setSelectedRowsData("");
  }

  const handleUpdateData = async (e) => {
    e.preventDefault();
    const {
      id,
      battery_num,
      battery_brand,
      specification,
      warrenty_guarantee,
      purchase_date,
    } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/battery/battery-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: selectedCompanyId,
        vehicle_id: selectedVehicleId,
        driver_id: selectedStafflId,
        battery_num,
        battery_brand,
        specification,
        warrenty_guarantee,
        purchase_date: moment(purchase_date).format("YYYY-MM-DD"),
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    if (selectedRowsData) {
      getCompany();
    }
  }, [selectedRowsData]);

  useEffect(() => {
    if (selectedRowsData) {
      setSelectedCompanyId(selectedRowsData?.company_id);
      setSelectedStaffId(selectedRowsData?.driver_id);
      setSelectedVehicleId(selectedRowsData?.vehicle_id);
    }
  }, [selectedRowsData]);

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setSelectedCompanyId(value ? value : "");
    setStaff("");
  };

  const getStaff = async (e) => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStaff(result.data);
    } else {
      setStaff([]);
    }
  };
  useEffect(() => {
    if (selectedCompanyId) {
      getStaff();
    }
  }, [selectedCompanyId]);

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    if (selectedRowsData) {
      getVehicle();
    }
  }, [selectedRowsData]);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Battery Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form className="form-sample" onSubmit={handleUpdateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="battery_num">Battery Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="battery_num"
                              id="battery_num"
                              placeholder="Battery Number"
                              onChange={selectedRowsData?.battery_num}
                              value={selectedRowsData?.battery_num}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="battery_brand">Battery Brand</label>
                            <input
                              type="text"
                              className="form-control"
                              name="battery_brand"
                              id="value"
                              placeholder="Battery Brand"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.battery_brand}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="specification">Specification</label>
                            <input
                              type="text"
                              className="form-control"
                              name="specification"
                              id="specification"
                              placeholder="Specification"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.specification}
                              required
                              min="1"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Warrenty Guarantee
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="warrenty_guarantee"
                              id="warrenty_guarantee"
                              placeholder="Warrenty Guarantee"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.warrenty_guarantee}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="purchase_date">Purchase Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="purchase_date"
                              id="purchase_date"
                              placeholder="Purchase Date"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.purchase_date}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateBatteryDetails;
